import styled from '@emotion/styled';

/**
 * Section wrapper for Nike AI search element
 * Uses fixed grid positioning (3/9) to align with search input
 * Never changes position - stays aligned with search bar
 */
export const SectionWrapper = styled.div`
  grid-column: 3/9;
  padding: 12px 0;
  margin-bottom: 24px;

  @media (max-width: 959px) {
    grid-column: span 10;
    padding: 12px 24px 24px 24px;
  }
`;
